import React from "react";
import BaseModal from "../common/HPBaseModal";
import { ModalProps } from "../../_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";
import { TrashIconWhite } from "@/assets/images";

interface DeleteWidgetConfirmationModalProps extends ModalProps {
  onConfirm: () => void;
  widgetType: string;
}

const DeleteWidgetConfirmationModal: React.FC<
  DeleteWidgetConfirmationModalProps
> = ({ onConfirm, widgetType }) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  const handleConfirm = () => {
    onConfirm();
    closeTopModal();
  };

  const deleteText = widgetType === "Chart" ? "Visualization" : widgetType;

  return (
    <BaseModal
      title="Delete Widget?"
      message={
        <span>
          Are you sure you want to delete this <strong>{deleteText}</strong>{" "}
          widget? This action cannot be undone.
        </span>
      }
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      confirmButtonIcon={<TrashIconWhite className="w-4 h-4" />}
      onConfirm={handleConfirm}
      onCancel={closeTopModal}
    />
  );
};

export default DeleteWidgetConfirmationModal;
